/**
 * Admin WhatsApp Migration API
 */

import type { z } from "zod";

import { ApiSuccessSchema } from "../../common/response.schema";
import type { InferSchemas } from "../../schema-inference";
import {
  MigrateWhatsAppWebhookBodySchema,
  MigrateWhatsAppWebhookResponseSchema,
  WhatsAppMigrationRecordSchema,
  WhatsAppMigrationStatusResponseSchema
} from "./schemas/whatsapp-migration.schemas";

export const ZAdminWhatsAppMigration = {
  GetStatus: {
    method: "GET" as const,
    path: "/api/admin/webhook-migration/whatsapp/status",
    Response: ApiSuccessSchema(WhatsAppMigrationStatusResponseSchema)
  },
  Migrate: {
    method: "POST" as const,
    path: "/api/admin/webhook-migration/whatsapp/migrate",
    Body: MigrateWhatsAppWebhookBodySchema,
    Response: ApiSuccessSchema(MigrateWhatsAppWebhookResponseSchema)
  }
} as const;

export type TApiAdminWhatsAppMigration = InferSchemas<typeof ZAdminWhatsAppMigration>;

// ============================================================
// Convenience Type Exports
// ============================================================

export type WhatsAppMigrationRecord = z.infer<typeof WhatsAppMigrationRecordSchema>;
export type WhatsAppMigrationStatusResponse = z.infer<typeof WhatsAppMigrationStatusResponseSchema>;
